import React, { useState, useEffect } from 'react';

function SimpleScoreboard({ currentScore, periodType, compact = false }) {
  const [displayScore, setDisplayScore] = useState(currentScore || 0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    if (currentScore !== displayScore && currentScore !== undefined && currentScore !== null) {
      setIsFading(true);
      // Wait for fade-out to complete before updating score
      const fadeOutTimeout = setTimeout(() => {
        setDisplayScore(currentScore);
        setIsFading(false);
      }, 300); // Matches fade-out duration

      return () => clearTimeout(fadeOutTimeout);
    }
  }, [currentScore, displayScore]);

  const textStyle = {
    color: '#FFF',
    textAlign: 'right',
    fontFamily: '"DM Sans"',
    fontSize: compact ? '12px' : '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: compact ? '14px' : '16px', // 114.286%
  };

  const scoreStyle = {
    color: '#FFF',
    textAlign: 'right',
    fontFamily: '"DM Sans"',
    // compact (telefoon): kleiner, anders valt 'ie over de lijst
    fontSize: compact ? '32px' : '64px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '100%', // 64px
    opacity: isFading ? 0 : 1,
    transition: 'opacity 0.3s ease-in-out', // Fade effect
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end', // Aligns child elements (spans) to the right
      textAlign: 'right',     // Aligns text within the spans to the right
      gap: compact ? '4px' : '8px',
    }}>
      
      <span style={textStyle}>
        {periodType === "TODAY" ? "Orders Today" : "Orders This Month"}
      </span>
      <span style={scoreStyle}>{displayScore}</span>
   
    </div>
  );
}

export default SimpleScoreboard;